import { render, staticRenderFns } from "./MessageList.vue?vue&type=template&id=27d50ac6&scoped=true&"
import script from "./MessageList.vue?vue&type=script&lang=js&"
export * from "./MessageList.vue?vue&type=script&lang=js&"
import style0 from "./MessageList.vue?vue&type=style&index=0&id=27d50ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d50ac6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d50ac6')) {
      api.createRecord('27d50ac6', component.options)
    } else {
      api.reload('27d50ac6', component.options)
    }
    module.hot.accept("./MessageList.vue?vue&type=template&id=27d50ac6&scoped=true&", function () {
      api.rerender('27d50ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Message/MessageList.vue"
export default component.exports